<nz-collapse nzGhost nzAccordion="true" class=" no-rotate-accordion px-0">
    <ng-container *ngFor="let child of catalogs;let i=index trackBy: trackByCatalogId">
        <div class="product-item position-relative" [ngClass]="{ 'collapse-hover': child.hovered && !child['isOpen']}"
            [class.selected-item]="child['styleId'] + child['version'] == selectedCatalogId"
            (mouseenter)="$event.stopPropagation();handleHover(child,catalogs,true)"
            (mouseleave)="$event.stopPropagation();handleHover(child,catalogs,false)" (click)="loadCatalog(child)">
            <div class="d-flex custom-header align-items-center justify-content-between"
                [ngClass]="child['oldCatalogName'] && child['oldCategoryName'] ? 'mb-0' : 'mb-2'"
                (click)="preventCollapse($event);loadCatalog(child)">
                <div class="d-flex flex-column">
                    <span class="mr-10">{{ child['styleId']}} @if(child['version']){
                        <span class="ml-10 px-1"> &nbsp; --> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ child['version']}} </span>
                        }
                    </span>


                    <span [innerHTML]="child['displayName']" style="font-size: 13px;" class="mr-10"></span>
                    <div class="w-100 d-flex justify-content-between">
                        @if(child['oldCatalogName'] && child['oldCategoryName'] ) {
                        <span [innerHTML]="child['oldCatalogName'] + ' ' + '/' + ' ' + child['oldCategoryName'] "
                            style="font-size: 12px;color: #c38509;" class="mr-10 fst-italic"></span>
                        }
                        <span (click)="$event.stopPropagation();openProducts(child)" nz-tooltip
                            nzTooltipTitle="Linked Products"
                            [ngClass]="{ 'badge-position':(child['oldCatalogName'] && child['oldCategoryName'] ) && ( child['displayName'] && child['displayName'].length > 40 )}"
                            class="badge badge-circle mt-0 position-absolute">{{child?.totalLinkedProducts}}</span>
                    </div>
                </div>
                <div class="d-flex align-items-center">
                    @if(child['salsify']){
                    <nz-tag nz-tooltip nzTooltipTitle="The details of this product are from Salsify">Salsify</nz-tag>
                    }
                    @if(child['deleteInd'] == 1){
                    <nz-tag class="deleteIndTag">Deleted</nz-tag>
                    }
                    @if(!child['salsify'] && !applyStyleAction){
                    <span (click)="$event.stopPropagation()" style="width: 20px;height: 20px;transform: rotate(90deg);"
                        nz-dropdown nz-icon nzTrigger="click" [nzType]="'ellipsis'" [nzDropdownMenu]="menu"></span>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu class="category-options px-1 mt-1">
                            @if(child["version"] && child['deleteInd'] == 0){
                            <li nz-tooltip="Merge this version with the Style's default version"
                                nzTooltipPlacement="right" (click)="mergeCatalog(child)" nz-menu-item
                                [nzDisabled]="!authService.MCAdd">
                                <!-- <i class="dropdown-icon px-1" nz-icon
                                    [nzType]="'merge-cells'"></i> -->
                                <img class="dropdown-icon px-0" [src]="'merge-cells.svg'" />
                                Merge
                            </li>
                            }
                            @if(child["version"] && child['deleteInd'] == 0){
                            <li nz-tooltip="Move this version under a different Style" nzTooltipPlacement="right"
                                (click)="moveCatalog(child)" nz-menu-item [nzDisabled]="!authService.MCAdd">
                                <!-- <i
                                    class="dropdown-icon px-1" nz-icon [nzType]="'export'"></i> -->
                                <img class="dropdown-icon px-0" [src]="'export.svg'" />
                                Move
                            </li>
                            }
                            @if(!child["version"] && child['deleteInd'] == 0){
                            <li (click)="copyCatalog(child)" nz-menu-item [nzDisabled]="!authService.MCAdd">
                                <!-- <i
                                    class="dropdown-icon px-1" nz-icon [nzType]="'copy'"></i> -->
                                <img class="dropdown-icon px-0" [src]="'copy.svg'" />
                                Create a New Version
                            </li>
                            }
                            <li (click)="deleteCatalog(child)" nz-menu-item [nzDisabled]="!authService.MCDelete">
                                <!-- <i
                                    class="dropdown-icon px-1" nz-icon
                                    [nzType]="child['deleteInd'] == 1 ? 'undo': 'delete'"></i> -->

                                <img class="dropdown-icon px-0"
                                    [src]="child['deleteInd'] == 1 ? 'undo.svg': 'delete.svg'" />

                                {{ child['deleteInd'] == 1
                                ? 'Undelete' : 'Delete' }}
                            </li>
                            @if(!child["version"] && child['deleteInd'] == 0){
                            }
                        </ul>
                    </nz-dropdown-menu>
                    }
                    @if(child['salsify'] && !applyStyleAction){
                    <span (click)="$event.stopPropagation()" style="width: 20px;height: 20px;transform: rotate(90deg);"
                        nz-dropdown nz-icon nzTrigger="click" [nzType]="'ellipsis'" [nzDropdownMenu]="menu"></span>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu class="category-options px-1 mt-1">
                            <li (click)="copyCatalog(child)" nz-menu-item [nzDisabled]="!authService.MCAdd"> <i
                                    class="dropdown-icon px-1" nz-icon [nzType]="'copy'"></i>Create a New Version</li>
                        </ul>
                    </nz-dropdown-menu>
                    }
                </div>

            </div>
        </div>
    </ng-container>
</nz-collapse>
<app-confirm-popup *ngIf="showModal" [title]="modalButton" [message]="modalMessage" [confirmText]="modalButton"
    [triggerModal]="showModal" [cancelText]="'Cancel'" [modalwidth]="modalWidth" (confirm)="onConfirm()"
    (cancel)="showModal =false"></app-confirm-popup>

<nz-modal (nzOnOk)="showMovePopup = false" [nzFooter]="modalFooter" (nzOnCancel)="showMovePopup = false"
    [nzMaskClosable]="false" nzCentered [nzWidth]="780" [(nzVisible)]="showMovePopup"
    [nzBodyStyle]="{ overflowY: 'auto' }" [nzClosable]="moveBtn =='Moving' ? false : true">
    <ng-container *nzModalContent>
        <div class="container move-modal d-flex flex-column px-4 py-0">
            <div class="d-flex mb-3">
                <span class="quest-icon" nz-icon nzType="question-circle"></span>
                <b class="px-3">Move</b>
            </div>
            <span class=" content d-flex align-items-center">Moving style version(s) <nz-tag class="ml-5">{{
                    modaltitle.styleId }}</nz-tag> -> <nz-select [nzDisabled]="moveBtn =='Moving'"
                    nzPlaceHolder="Select" nzSize="default" [(ngModel)]="versionList" class="mx-1" [nzMaxTagCount]="1"
                    [nzShowSearch]="true" nzMode="multiple" style="height: 35px !important;width: 210px;">
                    @for(style of selectedStyleIdList; track style){
                    @if(style.version){
                    <nz-option [nzLabel]="style.version" [nzValue]="style"></nz-option>
                    }
                    }
                </nz-select> &nbsp; to new style.
            </span>
            @if(versionList.length == 0 && (selectedStyleIdList && selectedStyleIdList.length>1)){
            <span class="text-danger mr-100 justify-content-end d-flex">Atlease one Version selection is required</span>
            }
            <div class="col-md-12 d-flex mt-5 align-items-center product-search-container p-0 mb-3 ml-5">
                <span class="content px-4 mb-0">Please select the new Style</span>
                <div class="d-flex flex-column w-50">
                    <nz-select [nzDisabled]="moveBtn =='Moving'" nzPlaceHolder="Select" nzSize="default"
                        [(ngModel)]="newStyleId" [nzShowSearch]="true" style="height: 35px !important;">
                        @for(style of styleIdList; track style){
                        <nz-option [nzLabel]="style" [nzValue]="style"></nz-option>
                        }
                    </nz-select>
                </div>
            </div>
        </div>

    </ng-container>
    <ng-template #modalFooter>
        <button nz-button (click)="showMovePopup = false" nzType="default">Cancel</button>
        <button [nzLoading]="moveBtn == 'Moving'" nz-button [disabled]="!newStyleId" (click)="confirmMoveAction()"
            nzType="primary">{{moveBtn}}</button>
    </ng-template>
</nz-modal>

<nz-modal (nzOnOk)="showMergeModal = false" [nzFooter]="mergeModalFooter" (nzOnCancel)="showMergeModal = false"
    [nzMaskClosable]="false" nzCentered [nzWidth]="950" [(nzVisible)]="showMergeModal"
    [nzBodyStyle]="{ overflowY: 'auto' }" [nzClosable]="mergeBtn =='Merging' ? false : true">
    <ng-container *nzModalContent>
        <div class="container merge-modal d-flex flex-column px-2 py-1">
            <div class="d-flex mb-3">
                <span class="quest-icon" nz-icon nzType="question-circle"></span>
                <b class="px-3">Merge</b>
            </div>
            <span class="content">
                Merging Style version(s) <nz-tag class="ml-5">{{
                    selectedCatalogDetails.styleId }}</nz-tag> -> <nz-select [nzDisabled]="mergeBtn =='Merging'"
                    nzPlaceHolder="Select" nzSize="default" [(ngModel)]="versionList"
                    (ngModelChange)="alterMergeList(versionList)" [nzMaxTagCount]="1" [nzShowSearch]="true"
                    nzMode="multiple" style="height: 35px !important;width: 210px;">
                    @for(style of selectedStyleIdList; track style){
                    @if(style.version){
                    <nz-option [nzDisabled]="style?.disabled" [nzLabel]="style.version" [nzValue]="style"></nz-option>
                    }
                    }

                </nz-select> with the <nz-select [nzDisabled]="mergeBtn =='Merging'" nzPlaceHolder="Select"
                    nzSize="default" [(ngModel)]="targetVersion" [nzShowSearch]="true"
                    style="height: 35px !important;width: 180px;" (ngModelChange)="alterSelectedList(targetVersion)">
                    @for(style of mergeStyleIdList; track style){
                    <nz-option [nzDisabled]="style?.disabled" [nzLabel]="style.version ? style.version : 'Default'"
                        [nzValue]="style"></nz-option>
                    }
                </nz-select>
                version.
            </span>
            @if(versionList.length == 0 && (selectedStyleIdList && selectedStyleIdList.length>1)){
            <span class="text-danger ml-50 justify-content-center d-flex">Atlease one Version selection is
                required</span>
            }
            <br>
            <span class="content">
                Merging will permanently remove the selected version(s) and move all the associated customer catalog
                products to
                the newly
                selected version of the style.<br><br>
                Are you sure to continue?
            </span>
            <br>
            <div class="form-check">
                <input
                    [disabled]="(versionList && versionList.length > 1) || (targetVersion && targetVersion.salsifyIndicator)"
                    [(ngModel)]="overwriteDefaultStyleVersion" class="form-check-input" type="checkbox">
                <label class="form-check-label"> Overwrite Product Information</label>
            </div>
            <br>
            @if(targetVersion?.productsLinked && overwriteDefaultStyleVersion) {
            <span class="text-danger fw-bold">The selected version has customer catalog products linked.</span>
            }
        </div>
    </ng-container>
    <ng-template #mergeModalFooter>
        <button nz-button (click)="showMergeModal = false" nzType="default">Cancel</button>
        <button [nzLoading]="mergeBtn == 'Merging'" nz-button
            [disabled]="(!targetVersion?.version && !targetVersion) || (versionList && versionList.length == 0 )"
            (click)="confirmMergeAction()" nzType="primary">{{mergeBtn}}</button>
    </ng-template>
</nz-modal>
<nz-drawer [nzMaskClosable]="false" [nzKeyboard]="false" [nzWidth]="1000" [nzVisible]="productList"
    nzTitle="Linked Products" (nzOnClose)="productList = !productList" [nzExtra]="extraActions">

    <ng-container *nzDrawerContent>
        <app-associated-products #associatedProdComp [selectedProdctId]="selectedProdctId"
            [selectedVersion]="selectedProdctVersion" (emitParentData)="updateToggle($event)">
        </app-associated-products>
    </ng-container>
</nz-drawer>


<ng-template #extraActions>
    <label class="form-label mb-0 px-1">Collapse All</label>
    <nz-switch class="toggle"   [(ngModel)]="isAllExpanded" (ngModelChange)="associatedProductsComponent.collapseAllProducts($event)"></nz-switch>
</ng-template>
